import { IActivity, ICourse } from '@sdk/contracts';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { useActivityForm } from '@/store';

type Props = {
  activity: IActivity;
  sectionId: string;
  course: ICourse;
};
export const EditActivity: React.FC<Props> = ({ activity, sectionId, course }) => {
  const { setIsOpen, setData, setSectionId, setCourse } = useActivityForm();
  const { t } = useTranslation('DefaultTranslations');

  const handleEditActivity = () => {
    setCourse(course);
    setData(activity);
    setSectionId(sectionId);
    setIsOpen(true);
  };

  return (
    <Tooltip title={t('EDIT')}>
      <Button type="text" icon={<Icon i="Edit" size={20} />} onClick={handleEditActivity} />
    </Tooltip>
  );
};
